<template>
  <div class="product-boards m-t-20">
    <SfAccordion
      :multiple="true"
      transition="sf-expand"
    >
      <SfAccordionItem
        v-for="board in boards"
        :key="board.Serie"
        :header="board.Serie"
      >
        <div class="board-table">
          <SfTable>
            <SfTableHeading>
              <SfTableHeader v-for="header in tableHeaders" :key="header">
                {{ $t(header) }}
              </SfTableHeader>
            </SfTableHeading>
            <SfTableRow
              v-for="(detail, index) in board.BoardDetail"
              :key="`${detail.Id}-${board.Serie}-${index}`"
            >
              <SfTableData v-for="header in tableHeaders" :key="header">
               {{ detail[header] }}
              </SfTableData>
            </SfTableRow>
          </SfTable>
        </div>
      </SfAccordionItem>
    </SfAccordion>
  </div>
</template>

<script>
import { SfAccordion, SfTable } from '@storefront-ui/vue';

export default {
  name: 'ProductBoards',
  components: {
    SfAccordion,
    SfTable,
  },
  props: {
    boards: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tableHeaders: [
        'Model',
        'Engine',
        'Body',
        'Version',
        'Id',
        'Position',
        'Name',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
